import { EventConfig, EventConfigResponse } from '@/types/event.types';

/**
 * Event Configuration Service
 * Fetches event configuration from backend API
 */
export class EventConfigService {
  private baseUrl: string;

  constructor(baseUrl: string = 'http://localhost:3000/api') {
    this.baseUrl = baseUrl;
  }

  /**
   * Fetch event configuration by slug
   * @param eventSlug - Event slug (e.g., 'mock-event-1')
   * @returns Event configuration
   * @throws Error if fetch fails or event not found
   */
  async getConfig(eventSlug: string): Promise<EventConfig> {
    try {
      const response = await fetch(`${this.baseUrl}/events/${eventSlug}/config`);

      if (!response.ok) {
        if (response.status === 404) {
          throw new Error(`Event not found: ${eventSlug}`);
        }
        throw new Error(`Failed to fetch event config: ${response.statusText}`);
      }

      const data: EventConfigResponse = await response.json();

      if (!data.success || !data.data) {
        throw new Error('Invalid response format from server');
      }

      console.log('[EventConfigService] Config loaded successfully', {
        eventSlug,
        eventName: data.data.event.name,
        courseName: data.data.course.name,
      });

      return data.data;
    } catch (error) {
      console.error('[EventConfigService] Failed to load config', { eventSlug, error });
      throw error;
    }
  }
}
